"use client";

import { ArrowUp } from "lucide-react";

/** The footer's only interactive bit, split out so the footer itself stays a Server Component. */
export default function BackToTopButton({ label }: { label: string }) {
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Scroll back to the top of the page"
      className="group inline-flex cursor-pointer items-center gap-2 text-xs font-semibold uppercase tracking-wider text-foreground/70 transition-colors hover:text-orange-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 dark:text-zinc-400 dark:hover:text-orange-400"
    >
      {label}
      <ArrowUp
        size={14}
        className="transition-transform duration-200 group-hover:-translate-y-0.5 text-orange-500"
      />
    </button>
  );
}
